import { useCallback } from "react";
import html2canvas from "html2canvas";

const useScreenshotCapture = () => {
  const captureScreenshot = useCallback(async () => {
    try {
      const canvas = await html2canvas(document.documentElement, {
        useCORS: true,
        logging: false,
        ignoreElements: (el) => el.classList?.contains('some-hidden-class')
      });
      
      return new Promise((resolve) => {
        canvas.toBlob((blob) => {
          if (blob) {
            const screenshotFile = new File([blob], "screenshot.png", { 
              type: "image/png" 
            });
            resolve(screenshotFile);
          } else {
            resolve(null);
          }
        });
      });
    } catch (error) {
      console.error("Error capturing screenshot:", error);
      return null;
    }
  }, []);

  const captureAndSetScreenshot = useCallback(async () => {
    const screenshot = await captureScreenshot();
    
    return screenshot;
  }, [captureScreenshot]);

  return {
    captureScreenshot,
    captureAndSetScreenshot
  };
};

export default useScreenshotCapture;